<template>
  <SimpleComparisonRow :apply-sync="true"
                       no-padding-bottom no-padding-top no-border
                       :data="data"
                       :number-products="numberProducts"
                       :index="index"
                       :no-highlight="$parent.noHighlight"
  >
    <template v-slot="{ columnData }">
      <div class="similar-comparison-data-body facts-body">
        <span v-if="Array.isArray(columnData.value) && columnData.value.length > 0" v-for="value in columnData.value" :key="value" class="fact-value" v-html="formatValue(value)">
        </span>
        <span v-else class="fact-value">-</span>
      </div>
    </template>
  </SimpleComparisonRow>
</template>

<script setup>
import SimpleComparisonRow from '@/components/shared/simple-comparison/SimpleComparisonRow';
function formatValue(value) {
  //if value is object and has `name` then take `name` property
  if (typeof value === 'object' && 'name' in value) {
    return value.name
  }

  //if value is numeric string then convert it to number
  if (typeof value === 'string' && !isNaN(value)) {
    return Number(value)
  }

  //if value is boolean then convert it to string
  if (typeof value === 'boolean') {
    return value ? '&check;' : '&cross;'
  }

  return value
}
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  numberProducts: {
    type: Number,
    default: 3,
  },
  index: {
    type: Number,
    default: 0,
  },
  includes: {
    type: Array,
    default: () => [],
  },
  excludes: {
    type: Array,
    default: () => [],
  },
})
</script>

<style lang="scss" scoped>
.similar-comparison-data-body {
  &.facts-body {
    padding-bottom: 0;
  }
  a.price-value {
    display: block;
  }
  stars-rating {
    position: relative;
    top: 1px;
  }
  .corescore {
    @extend %overall-score-medium;
    @extend %corescoreColors;
    font-weight: 300;
  }
  .fact-title {
    font-weight: bold;
    height: 20px;
    display: block;
  }
  &.facts-body {
    display: block;
    .fact-value {
      display: block;
    }
  }
}
</style>
